// extracted by mini-css-extract-plugin
module.exports = {"blurred":"styles_blurred__2QfEP"};